export class GetBillingPeriodsResponse {
    'periods';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "periods",
            "baseName": "periods",
            "type": "Array<BillingPeriod>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetBillingPeriodsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
